let isPerceptUserIdSet = false;
      let shopAnalytics = Shopify.analytics;
      document.addEventListener('DOMContentLoaded', function () {
        function logoutClickHandler(event) {
          event.preventDefault();
          shopAnalytics.publish('percept_logout_user');
          setTimeout(() => (window.location.href = event.target.href), 300);
        }

        function addClickListenerToLogoutBtn() {
          const links = document.querySelectorAll('a[href="/account/logout"]');
          links.forEach((link) => {
            link.addEventListener('click', (event) => logoutClickHandler(event));
          });
        }

        addClickListenerToLogoutBtn();

        if (window.parent && window.parent.dataLayer) {
          let lastCartId = null;

          function setPerceptUserIdFromShiprocketEvent(event) {
            if (isPerceptUserIdSet) return;
            if (event.phone_num) {
              let customerDataObj = {
                id: `${event.phone_num}`.replace('+91', ''),
                name: (event.first_name ?? '') + ' ' + (event.last_name ?? ''),
                email: event.email,
                phone: event.phone_num,
                shopifyCustomerId: event.Shopify_Customerid,
              };
              shopAnalytics.publish('percept_identify_user', { ...customerDataObj });
              isPerceptUserIdSet = true;
            }
          }

          function getCommonPropsFromEcommerceObj(ecommerce) {
            if (!ecommerce) return {};
            return {
              cart_currency: ecommerce.currency,
              cart_total_value: ecommerce.value,
              cart_coupon: ecommerce.coupon,
              cart_items: ecommerce.items.map((i) => i.name),
              cart_itemIds: ecommerce.items.map((i) => i.itemId),
            };
          }

          function getCommonPropsFromEventExceptEcommerce(eventData) {
            return {
              user_email: eventData.email,
              user_phone_num: eventData.phone_num,
              user_name: eventData.first_name + ' ' + (eventData.last_name ?? ''),
              delivery_pincode: eventData.pincode,
              delivery_city: eventData.city,
              delivery_state: eventData.state,
              delivery_country: eventData.country,
              shipping_tier: eventData.shipping_tier,
              payment_type: eventData.payment_type,
            };
          }

          // trigered on buy now click
          function handleCartInitEvent(event) {
            if (event && event.cart_id) {
              if (lastCartId !== event.cart_id) {
                const cartId = event.cart_id;
                const ecommerce = event.ecommerce || null;
                if (ecommerce) {
                  let checkoutObj = {
                    ...getCommonPropsFromEcommerceObj(ecommerce),
                    cart_id: cartId,
                  };
                  let eventObj = {
                    eventName: 'cart_init_shiprocket',
                    eventData: { ...checkoutObj },
                  };
                  window.percept?.capture('cart_init_shiprocket', { ...eventObj.eventData });
                  shopAnalytics.publish('percept_custom_event', eventObj);
                }
                lastCartId = event.cart_id;
              }
            }
          }

          // triggered when the customer adds or fetches their address details on the checkout page
          function handlePaymentScreenEvent(event) {
            let eventObj = {
              eventName: 'payment_screen_shiprocket',
              eventData: {
                ...getCommonPropsFromEcommerceObj(event.ecommerce || null),
                ...getCommonPropsFromEventExceptEcommerce(event),
              },
            };
            window.percept?.capture('payment_screen_shiprocket', { ...eventObj.eventData });
            shopAnalytics.publish('percept_custom_event', eventObj);
          }

          // triggered when the payment process is initiated
          function handlePaymentInitEvent(event) {
            let eventObj = {
              eventName: 'payment_init_shiprocket',
              eventData: {
                ...getCommonPropsFromEcommerceObj(event.ecommerce || null),
                ...getCommonPropsFromEventExceptEcommerce(event),
              },
            };
            window.percept?.capture('payment_init_shiprocket', { ...eventObj.eventData });
            shopAnalytics.publish('percept_custom_event', eventObj);
          }

          // triggered when the order is successfully placed
          function handleOrderPlacedEvent(event) {
            let eventObj = {
              eventName: 'order_placed_shiprocket',
              eventData: {
                ...getCommonPropsFromEcommerceObj(event.ecommerce || null),
                ...getCommonPropsFromEventExceptEcommerce(event),
              },
            };
            window.percept?.capture('order_placed_shiprocket', { ...eventObj.eventData });
            shopAnalytics.publish('percept_custom_event', eventObj);
          }

          function captureInfoWithGtag(eventName) {
            if (typeof gtag === 'function') {
              gtag('event', eventName);
            } else {
              console.log('gtag is not defined');
            }
          }

          function checkForShiprocketEvent(data) {
            console.log('checking for shiprocket event: ', data);
            if (data.event === 'cart-init') {
              captureInfoWithGtag('cart-init-shiprocket');
              handleCartInitEvent(data);
            }
            if (data.event === 'payment-screen') {
              captureInfoWithGtag('payment-screen-shiprocket');
              setPerceptUserIdFromShiprocketEvent(data);
              handlePaymentScreenEvent(data);
            }
            if (data.event === 'payment-init') {
              captureInfoWithGtag('payment-init-shiprocket');
              setPerceptUserIdFromShiprocketEvent(data);
              handlePaymentInitEvent(data);
            }
            if (data.event === 'order-placed') {
              captureInfoWithGtag('order-placed-shiprocket');
              setPerceptUserIdFromShiprocketEvent(data);
              handleOrderPlacedEvent(data);
            }
          }

          function checkDataLayer() {
            window.parent.dataLayer.forEach(function (data) {
              checkForShiprocketEvent(data);
            });
          }

          function modifyDatalayerPush() {
            console.log('adding datalayer middleware');
            const originalPush = window.parent.dataLayer.push;
            window.parent.dataLayer.push = function () {
              originalPush.apply(this, arguments);
              const newEvent = arguments[0];
              checkForShiprocketEvent(newEvent);
            };
          }

          checkDataLayer();
          modifyDatalayerPush();
        } else {
          console.error('Unable to access parent dataLayer');
        }
      });